import { render } from "./NewNote.vue?vue&type=template&id=e1b2c366&scoped=true"
import script from "./NewNote.vue?vue&type=script&lang=js"
export * from "./NewNote.vue?vue&type=script&lang=js"

import "./NewNote.vue?vue&type=style&index=0&id=e1b2c366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b2c366"]])

export default __exports__